import * as mustache from 'mustache';

const LOCATION_DATA = [
  {
    id: 'null',
    name: 'Valitse',
  },
  {
    id: 'veho-airport',
    name: 'Veho Airport',
    Address: 'Ohtolankatu 10',
    Address2: '01510 Vantaa',
    Phone: '010 569 15',
    url: 'https://www.veho.fi/autoliikkeet/vantaa-veho-mercedes-benz-airport/'
  },
  {
    id: 'veho-olari',
    name: 'Veho Olari',
    Address: 'Piispankallio 2',
    Address2: '02200 Espoo',
    Phone: '010 569 17',
    url: 'https://www.veho.fi/autoliikkeet/olari/'
  },
  {
    id: 'veho-herttoniemi',
    name: 'Veho Herttoniemi',
    Address: 'Mekaanikonkatu 14',
    Address2: '00880 Helsinki',
    Phone: '010 569 14',
    url: 'https://www.veho.fi/autoliikkeet/helsinki-herttoniemi/'
  },
  {
    id: 'veho-turku',
    name: 'Veho Turku',
    Address: 'Vesilaitoksentie 1',
    Address2: '21200 Raisio, Turku',
    Phone: '010 569 2811',
    url: 'https://www.veho.fi/autoliikkeet/turku/'
  },
  {
    id: 'veho-tampere',
    name: 'Veho Tampere',
    Address: 'Taninkatu 11',
    Address2: '33400 Tampere',
    Phone: '010 569 3011',
    url: 'https://www.veho.fi/autoliikkeet/tampere-lielahti/'
  },
  {
    id: 'veho-suutarila',
    name: 'Veho Suutarila',
    Address: 'Valokaari 8 (Lampputie 4)',
    Address2: '00750 Helsinki',
    Phone: '010 569 18',
    url: 'https://www.veho.fi/autoliikkeet/helsinki-suutarila/'
  }
];


const locationExtraInformationTemplate  = `
<div class="data" >{{Address}}</div>
<div class="data" >{{Address2}}</div>
<div class="data">{{Phone}}</div>
<a href="{{url}}">Liikkeen tarkemmat tiedot</a>
`;

interface FooterDomElements {
  results?: HTMLElement;
  locationData?: HTMLElement;
  storeLocatorSelect?: HTMLInputElement;
}

/**
 * Handles logic attached to footer
 */
export default class Footer {

  /**
   * @property {Element} element This class only controls elements under this element. It's a scope of this class.
   */
  private element:HTMLElement;

  /**
   * @property {object} dom Items referenced in document object model are stored here.
   */
  dom:FooterDomElements = {};

  /**
   * @constructor
   * @param {HTMLElement} element main element
   */
  constructor(element:HTMLElement) {
    this.element = element;
    this.findElements();
    this.attacEventListeners();
    this.populateSelectOptions();
  }

  /**
   * Find element from DOM and stores them for a later use.
   * @private
   */
  private findElements() {
    this.dom.locationData = this.element.querySelector('#locationdata');
    this.dom.storeLocatorSelect = this.element.querySelector('.footer_store-locator select');
    this.dom.results = this.element.querySelector('.results');
  }

  /**
   * Bind event listeners
   * @private
   */
  private attacEventListeners() {
    this.dom.storeLocatorSelect.addEventListener('change', this.onStoreLocatorValueChanges.bind(this));
  }

  /**
   * Populate select options with actual data, on Veho.fi this stuff is fetched from Ajax endpoint
   */
  private populateSelectOptions() {
    const template = '{{#options}}<option value="{{id}}">{{name}}</option>{{/options}}';
    const html = mustache.render( template, {options: LOCATION_DATA});
    this.dom.storeLocatorSelect.innerHTML = html;
  }

  /**
   *
   */
  onStoreLocatorValueChanges() {
    const location = LOCATION_DATA.find( location => location.id === this.dom.storeLocatorSelect.value );
    const html = mustache.render( locationExtraInformationTemplate, location );
    this.dom.results.innerHTML = html;
    this.dom.results.classList.toggle('results--open', location.id !== 'null' );
  }

  /**
   * Initializes and bind logic in to DOM
   * @static
   */
  static init() {
    document.querySelectorAll('footer.footer').forEach( element => {
      new Footer( element as HTMLElement );
    })
  }
}
